import { AiFillFileText } from "react-icons/ai";
import { BiSupport } from "react-icons/bi";
import { FaEye, FaUserAlt } from "react-icons/fa";

function SubCountBox({ value, name, icon }) {
  const renderIcon = (i) => {
    switch (i) {
      case "eye":
        return <FaEye />;
      case "file-text":
        return <AiFillFileText />;
      case "headset":
        return <BiSupport />;
      case "user":
        return <FaUserAlt />;
    }
  };

  return (
    <div className="count-box">
      <i>{renderIcon(icon)}</i>
      <span>{value}</span>
      <p>{name}</p>
    </div>
  );
}

export default SubCountBox;
